(function () {
  document.querySelectorAll('[data-sova-hotspots]').forEach(function (root) {
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sova-hotspot-dot]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sova-hotspot-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sova-hotspot-content]'));
    if (!panels.length) return;

    function show(index) {
      dots.forEach(function (d) {
        d.classList.toggle('is-active', d.getAttribute('data-index') === String(index));
      });
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-index') === String(index);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-index') === String(index));
      });
    }

    dots.concat(tabs).forEach(function (el) {
      el.addEventListener('click', function () {
        show(parseInt(el.getAttribute('data-index'), 10));
      });
    });
  });
})();
